module.exports = __webpack_public_path__ + "static/media/206-Telefonat_ID_17m_v2.c389901e.mp3";